import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import CallsResults from './CallsResults';

const CallsResultsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Resultados dos Chamados',
            }}
        >
            <CallsResults />
        </ServicesChartsDataProvider>
    );
};

export default CallsResultsWrapper;
